module.exports = __webpack_public_path__ + "img/order_plate.c5fd9cfb.svg";